'use client';
import { CN_PRODUCT } from '@/components/product/const';
// import { useTranslation } from '@/i18n/client';
import { JDILogin } from '@/lib/jdiClientUtils';
import { EXPOSURE_RECORD } from '@/tracks/25217';
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils';
import { useParams } from 'next/navigation';
import { useEffect } from 'react';

export default function NewShopperActivity({ label }: { label: string }) {
  const { sku } = useParams();
  // const { t } = useTranslation();
  useEffect(() => {
    JDILogin.getInstance()
      .getUserInfo()
      .then((user: { isLoggedIn: boolean }) => {
        eventTrackingUtils.submitExp({
          event_id: EXPOSURE_RECORD.Productdetail_WelcomeOffer_Expo,
          json_param: [
            {
              mainskuid: sku,
              is_login: user.isLoggedIn ? '1' : '0',
              displayText: label,
            },
          ],
        });
      });
  }, [label, sku]);
  return (
    <div className={CN_PRODUCT('new-shopper')}>
      {/* <span className="flag">{t("welcome.title")}</span> */}
      <span className='flag'>{label}</span>
    </div>
  );
}
